var _a;
import { appointmentMethod } from './ehrNoteEnums';
import { inPerson, telehealth } from './strings';
export var appointmentMethods = (_a = {},
    _a[appointmentMethod.telehealth] = {
        label: telehealth,
    },
    _a[appointmentMethod.inPerson] = {
        label: inPerson,
    },
    _a);
export var AppointmentMethodsAsOptions = Object.entries(appointmentMethods).map(function (_a) {
    var k = _a[0], v = _a[1];
    return ({
        value: k,
        label: v.label,
    });
});
